/**
 * KD3 S2126 (BUG-S2126-001): ตรวจ "รหัสนี้มีแล้วหรือยัง" จากผลของ endpoint รายการที่กรองแบบ substring
 * รหัสสั้นเป็นส่วนหนึ่งของรหัสยาวได้ (KD3-C-001 อยู่ใน KD3-C-0010) → ต้องเทียบตรงตัว
 * ไม่สนตัวพิมพ์/ช่องว่างหัวท้าย ให้ตรงกับ unique ของ DB (utf8mb4_unicode_ci)
 */
export function isExactCodeMatch(codes: Array<string | null | undefined>, code: string): boolean {
  const target = (code ?? '').trim().toLowerCase();
  if (!target) return false;
  return codes.some(c => (c ?? '').trim().toLowerCase() === target);
}
